"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Inline = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireWildcard(require("react"));
var _reactKeyedFlattenChildren = _interopRequireDefault(require("react-keyed-flatten-children"));
var _spacing = require("../../constants/spacing");
var _layoutUtil = require("./layoutUtil");
/**
 * Component used for consistent, deterministic horizontal spacing.
 * Adapted from https://github.com/seek-oss/braid-design-system
 */

const Container = (0, _styled.default)("div")`
    // Apply padding top to this, and add an extra -1 to the
    // padding-top of the first child to prevent margin collapsing.
    padding-top: 1px;

    &::before {
        // Negative margin-top applied to the parent to shift everything up,
        // then apply the positive padding-top to each child.
        margin-top: ${_ref => {
  let {
    space
  } = _ref;
  return -space - 1;
}}px;
        content: "";
        display: block;
    }
`;
const Inner = (0, _styled.default)("div")`
    margin-left: ${_ref2 => {
  let {
    space
  } = _ref2;
  return -space;
}}px;
    display: flex;
    flex-wrap: wrap;
`;
const Inline = /*#__PURE__*/(0, _react.forwardRef)((_ref3, ref) => {
  let {
    children,
    space,
    innerWrapperProps,
    clientId,
    ...rest
  } = _ref3;
  const spaceInPx = typeof space === "number" ? space : _spacing.sizes[space];
  const childStyles = (0, _core.css)`
            min-width: 0;
            margin-top: ${spaceInPx}px;
            margin-left: ${spaceInPx}px;
        `;
  return /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
    space: spaceInPx,
    "data-client-id": clientId
  }, rest, {
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(Inner, (0, _extends2.default)({
    space: spaceInPx
  }, innerWrapperProps), _react.Children.map((0, _reactKeyedFlattenChildren.default)(children), child => child !== null && child !== undefined ? (0, _layoutUtil.cloneElement)(child, {
    css: childStyles
  }) : null)));
});
exports.Inline = Inline;
Inline.displayName = "Inline";
//# sourceMappingURL=Inline.js.map